import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ultilities',
  templateUrl: './ultilities.component.html',
  styleUrls: ['./ultilities.component.css']
})
export class UltilitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/ultilities/ultilities.component.ts